// Admin (operations + system_admin) layout — chrome lives in <AppShell>.
import AppShell from './AppShell';

export default function AdminLayout() {
  return <AppShell />;
}
